module.exports = __webpack_public_path__ + "6b97db3d1019e4f7b74204f3eb3a73a1.png";